import * as types from './action-types';
import * as forgotPasswordFormApi from '../api/forgot-password-form-api';
import * as apiResponseMessages from './api-response-messages';
import * as dataFormatHelper from './helpers/data-format-helper';
import * as messageHelper from './helpers/message-helper';
import { beginApiCall, apiCallError } from './api-status-actions';
import { formMessageConstants } from '../../components/utils/constants/form-message-constants';

export function loadSSOForgotPasswordFormDataSuccess(forgotPasswordFormData) {
    return { type: types.LOAD_FORGOT_PASSWORD_FORM_SUCCESS, forgotPasswordFormData };
}

export function loadSSOForgotPasswordFormDataError() {
    return { type: types.LOAD_FORGOT_PASSWORD_FORM_ERROR };
}

export function handleUserForgotPasswordSuccess(forgotPasswordMessages) {
    return { type: types.FORGOT_PASSWORD_SUCCESS, forgotPasswordMessages };
}

export function handleUserForgotPasswordError(forgotPasswordMessages) {
    return { type: types.FORGOT_PASSWORD_ERROR, forgotPasswordMessages };
}

export function resetForgotPasswordFormState() {
    return { type: types.RESET_FORGOT_PASSWORD_FORM_STATE };
}

export function loadSSOForgotPasswordFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return forgotPasswordFormApi.getSSOForgotPasswordFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSOForgotPasswordFormDataError());
                    return;
                }
                dispatch(loadSSOForgotPasswordFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSOForgotPasswordFormDataError());
                throw error;
            });
    };
}

export function handleUserForgotPassword(userForgotPasswordData, callBackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];
    return function (dispatch) {
        dispatch(beginApiCall());
        return forgotPasswordFormApi
            .handleUserForgotPassword(dataFormatHelper.getFormattedUserForgotPasswordData(userForgotPasswordData), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(handleUserForgotPasswordError(serverErrorMessages));
                    return;
                }
                const { actionSuccessText } = userForgotPasswordData;
                dispatch(handleUserForgotPasswordSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(handleUserForgotPasswordError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                dispatch(apiCallError([error]));
                throw error;
            });
    };
}
